export const Kittens = [
  {
    id: 1,
    name: "Katy Purry",
    username: "KP01",
    email: "KatyPurry@april.biz",
  },
  {
    id: 2,
    name: "Sushi",
    username: "Sushi02",
    email: "Sushi@fish.tv",
  },
  {
    id: 3,
    name: "Meowise",
    username: "Meowise03",
    email: "Meowise@yesenia.net",
  },
  {
    id: 4,
    name: "Jennifurr",
    username: "Jennifurr04",
    email: "Jennifurr@furr.org",
  },
  {
    id: 5,
    name: "Boots",
    username: "Boots05",
    email: "Boots@annie.ca",
  },
  {
    id: 6,
    name: "Wasabi",
    username: "Wasabi06",
    email: "Wasabi@jasper.info",
  },
  {
    id: 7,
    name: "Jiggles",
    username: "Jiggles07",
    email: "Jiggy@ziggy.biz",
  },
  {
    id: 8,
    name: "Sriracha",
    username: "Sriracha08",
    email: "Sriracha@sauce.me",
  },
  {
    id: 9,
    name: "Nugget",
    username: "Nugget09",
    email: "Nugget@maccas.io",
  },
  {
    id: 10,
    name: "Ramen",
    username: "Ramen10",
    email: "Ramen@noodle.biz",
  },
];
